import { Link } from 'react-router-dom';
import PageHero from '../shared/PageHero.jsx';
import Button from '../shared/Button.jsx';
import ImageSlot from '../shared/ImageSlot.jsx';
import Reveal from '../shared/Reveal.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor } from '../seo/routes.js';
import { leadStory, newsItems, upcomingEvents } from '../constants/news.js';

export default function News() {
  return (
    <>
      <Seo {...metaFor('/news')} path="/news" />

      <PageHero
        eyebrow="News & events"
        title="What happened this week, and what is coming next."
      />

      <section className="bg-cream pb-20 pt-5">
        <div className="mx-auto grid max-w-[1240px] items-start gap-[34px] px-5 sm:px-8 lg:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)]">
          <div>
            <Reveal
              as="article"
              className="overflow-hidden rounded-[30px] border-[3px] border-forest bg-white shadow-[0_10px_0_rgb(20_83_45_/_0.13)]"
            >
              <div className="aspect-16/7.5">
                <ImageSlot caption={leadStory.photoCaption} alt={leadStory.title} />
              </div>
              <div className="px-6 py-6">
                <p className="flex flex-wrap items-center gap-2.5">
                  <span className="rounded-full bg-coral px-2.5 py-1 text-xs font-extrabold uppercase tracking-[0.08em] text-white">
                    {leadStory.badge}
                  </span>
                  <time className="text-[13.5px] text-ink-soft/80">{leadStory.date}</time>
                </p>
                <h2 className="mt-2.5 font-display text-[31px] font-extrabold leading-[1.08] text-forest">
                  {leadStory.title}
                </h2>
                <p className="mt-2.5 text-base leading-[1.6] text-ink-soft">
                  {leadStory.body}
                </p>
                {/*
                  Every story on this page is on this page in full — there is no
                  article route to link off to yet, so the lead does not pretend
                  otherwise with a dead "read more".
                */}
              </div>
            </Reveal>

            <div className="mt-5.5 grid gap-5 sm:grid-cols-2">
              {newsItems.map((item, i) => (
                <Reveal
                  as="article"
                  key={item.title}
                  index={i}
                  className="rounded-3xl border-2 border-line bg-white p-5"
                >
                  <time className="text-[13px] text-ink-soft/80">{item.date}</time>
                  <h3 className="mt-1 font-display text-[21px] font-extrabold leading-[1.1] text-forest">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-[15px] leading-[1.5] text-ink-soft">
                    {item.body}
                  </p>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal className="rounded-[30px] bg-forest px-7 py-6 text-sage lg:sticky lg:top-[150px]">
            <h2 className="font-display text-2xl font-extrabold text-cream">Coming up</h2>
            <ol className="mt-4.5 flex flex-col gap-4">
              {upcomingEvents.map((event) => (
                <li key={event.title} className="flex gap-3.5">
                  <p className="w-[52px] flex-none rounded-xl bg-white/10 py-2 text-center">
                    <span className="block font-display text-xl font-extrabold leading-none text-sun">
                      {event.day}
                    </span>
                    <span className="block text-[11px] font-bold tracking-[0.06em]">
                      {event.month}
                    </span>
                  </p>
                  <p className="text-[14.5px] leading-[1.45]">
                    <b className="text-cream">{event.title}</b>
                    <br />
                    {event.detail}
                  </p>
                </li>
              ))}
            </ol>
            <Button as={Link} to="/contact" variant="sun" size="md" block className="mt-5.5">
              Ask about an event
            </Button>
          </Reveal>
        </div>
      </section>
    </>
  );
}
